import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { urlEndPoint } from 'src/app/common';
import { Router } from '@angular/router';
import { Foros } from '../../models/obs/foros';
import { ForosService } from 'src/app/services/obs/foros.service';
import { Tematic } from 'src/app/models/obs/tematic';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Message } from 'src/app/models/message';
import { Tier1Service } from '../../services/obs/tier1.service';
import { Tier1 } from 'src/app/models/obs/tier1';

@Component({
  selector: 'app-foros-futuro',
  templateUrl: './foros-futuro.component.html',
  styleUrl: './foros-futuro.component.scss'
})
export class ForosFuturoComponent implements OnInit {

  @ViewChild('searchInputRef', { static: false }) searchInputRef: ElementRef;
  @ViewChild('selectTematic', { static: false }) selectTematic: ElementRef;
  @ViewChild('selectYear', { static: false }) selectYear: ElementRef;

  // Opciones de temáticas y años
  yearOptions: string[] = [];
  tematic: Tematic[] = [];
  msg: Message;
  foros: Foros[] = [];
  URL: string = urlEndPoint;
  currentPage: number = 1;
  itemsPerPage: number = 8;
  filteredForos: Foros[] = [];
  selectedTematic: string = '0';
  selectedYear: number = 0;

  resultsEnct: boolean = false;
  showPaginator: boolean = true;

  dataCarousel: any;
  t1: Tier1;
  constructor(private t1S: Tier1Service, private forosService: ForosService, private renderer: Renderer2, private router: Router, private http: HttpClient, private tematicService: TematicService) { }

  ngOnInit() {
    this.getImgCarousel();
    this.getTematics();
    this.getInitialText();
    this.forosService.getAll().subscribe(
      (res: any) => {
        if (Array.isArray(res.data)) {
          this.foros = res.data;
          this.foros.sort((a, b) => {
            const episodeA = this.romanToNumber(a.episode);
            const episodeB = this.romanToNumber(b.episode);
            return episodeB - episodeA;
          });
          const anios = this.foros.map((year: any) => year.year.split('-')[0]);
          this.yearOptions = [...new Set(anios)].sort((a, b) => Number(b) - Number(a));
        } else {
          console.error('La respuesta del servicio no es un arreglo válido:', res);
        }
      },
      (error) => {
        console.error('Error al obtener datos desde la API:', error);
      }
    );
  }


  /*Listamos imagenes carousel*/
  getImgCarousel() {
    this.forosService.getImgCarousel().subscribe(
      (res: any) => {
        if (Array.isArray(res.data)) {
          this.dataCarousel = res.data;
          const ForosConImgCarousel = this.dataCarousel.filter(foro => foro.imgcarousel);
          this.dataCarousel = ForosConImgCarousel.map(foro => {
            return {
              longtitle: foro.title,
              img: foro.imgcarousel,
              eventtype: foro.episode + ' | ' + foro.group,
            };
          });
        } else {
          console.error('La respuesta del servicio no es un arreglo válido:', res);
        }
      },
      err => {
        console.error('Error al obtener datos desde la API:', err);
      }
    );
  }

  public getTematics() {
    this.tematicService.getAll().subscribe(
      res => {
        this.tematic = res['data'];
      },
      err => { this.msg = err; }
    );
  }

  public getInitialText() {
    this.t1S.getOne(25).subscribe(
      res => {
        this.t1 = res['data'];
      },
      err => { this.msg = err; }
    );
  }

  //Convertir Episodio en romanos a numeros
  romanToNumber(roman: string): number {
    const romanNumerals = {
      I: 1, IV: 4, V: 5, IX: 9, X: 10,
      XL: 40, L: 50, XC: 90, C: 100,
      CD: 400, D: 500, CM: 900, M: 1000
    };

    let num = 0;
    for (let i = 0; i < roman.length; i++) {
      const currentSymbol = roman[i];
      const nextSymbol = roman[i + 1];

      if (romanNumerals[currentSymbol] < romanNumerals[nextSymbol]) {
        num += romanNumerals[nextSymbol] - romanNumerals[currentSymbol];
        i = i + 2;
      } else {
        num += romanNumerals[currentSymbol];
      }
    }
    return num;
  }
  //Buscador
  performSearch(keyword: string) {
    const lowerCaseSearchTerm = keyword.toLowerCase();
    this.selectedTematic = '0';
    this.selectedYear = 0;
    if (lowerCaseSearchTerm === '') {
      this.filteredForos = [];
      this.resultsEnct = false; // Cambiado a false para mostrar todos los foros
      this.showPaginator = true;
    } else {
      this.filteredForos = this.foros.filter(foro =>
        foro.title.toLowerCase().includes(lowerCaseSearchTerm) || foro.episode.toLowerCase().includes(lowerCaseSearchTerm)
      );
      this.resultsEnct = this.filteredForos.length === 0;
      this.showPaginator = !this.resultsEnct; // Actualizado para mostrar u ocultar el paginador
    }

    this.currentPage = 1;
    this.searchInputRef.nativeElement.value = '';
    this.renderer.setProperty(this.selectTematic.nativeElement, 'value', this.selectedTematic);
    this.renderer.setProperty(this.selectYear.nativeElement, 'value', this.selectedYear);
  }

  getPageNumbers(): number[] {
    const totalForos = this.filteredForos.length > 0 ? this.filteredForos.length : this.foros.length;
    const totalPages = Math.ceil(totalForos / this.itemsPerPage);
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  isPageActive(pageNumber: number): boolean {
    return pageNumber === this.currentPage;
  }

  changePage(pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.getPageNumbers().length) {
      this.currentPage = pageNumber;
    }
  }

  getDisplayedForos(): Foros[] {
    if (this.filteredForos.length === 0) {
      // Mostrar todos los foros si no hay filtro aplicado
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.foros.slice(startIndex, endIndex);
    } else {
      // Mostrar los foros filtrados si hay filtro aplicado
      return this.filteredForos;
    }
  }

  //SELECTS
  selectedTematicChanged(value: string) {
    this.selectedTematic = value;
    this.selectForos();
  }

  selectedYearChanged(value: string) {
    this.selectedYear = parseInt(value, 10);
    this.selectForos();
    console.log(value)
  }

  selectForos() {
    if (this.selectedTematic === '0' && this.selectedYear === 0) {
      this.filteredForos = [];
      this.resultsEnct = false;
    } else {
      this.filteredForos = this.foros.filter(foro => {
        const foroYear = new Date(foro.year); // Convierte la cadena 'year' en un objeto Date
        const foroYearValue = foroYear.getFullYear(); // Obtiene el año de 'foroYear'

        // Compara el año de 'foroYear' con 'this.selectedYear'
        return (this.selectedTematic === '0' || foro.tematic === this.selectedTematic) &&
          (this.selectedYear === 0 || foroYearValue === this.selectedYear);
      });

      this.resultsEnct = this.filteredForos.length === 0;
    }

    this.currentPage = 1;
    this.showPaginator = !this.resultsEnct || (this.selectedTematic === '0' && this.selectedYear === 0);
  }

  onForoClick(foroId: number) {
    this.router.navigate(['./forosdelfuturo/foro-detalle', foroId]);
  }

}